var _path, _g, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_432_1531",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 0.833984H15.9141V15.2907H0.5V0.833984Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_432_1531)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.20584 2.08398C5.29334 2.08398 3.26334 4.36565 3.26334 6.41315C3.26334 8.14565 2.78251 8.94648 2.35751 9.65315C2.01668 10.2207 1.74751 10.669 1.74751 11.6432C1.88668 13.2148 2.92418 14.0407 8.20584 14.0407C13.4583 14.0407 14.5283 13.1782 14.6667 11.589C14.6642 10.669 14.395 10.2207 14.0542 9.65315C13.6292 8.94648 13.1483 8.14565 13.1483 6.41315C13.1483 4.36565 11.1183 2.08398 8.20584 2.08398ZM8.20584 15.2907C4.30918 15.2907 0.787511 15.0157 0.500011 11.6965C0.497511 10.3232 0.916678 9.62482 1.28668 9.00982C1.66084 8.38648 2.01334 7.79899 2.01334 6.41315C2.01334 3.71898 4.50168 0.833984 8.20584 0.833984C11.91 0.833984 14.3983 3.71898 14.3983 6.41315C14.3983 7.79899 14.7508 8.38648 15.125 9.00982C15.495 9.62482 15.9142 10.3232 15.9142 11.6432C15.6233 15.0157 12.1025 15.2907 8.20584 15.2907Z",
    fill: "#5D6373"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16486 18.7515H8.16319C7.22903 18.7506 6.34486 18.339 5.67403 17.5915C5.44319 17.3356 5.46403 16.9398 5.72069 16.7098C5.97736 16.4781 6.37236 16.499 6.60319 16.7565C7.03486 17.2373 7.58903 17.5015 8.16403 17.5015H8.16486C8.74236 17.5015 9.29903 17.2373 9.73153 16.7556C9.96319 16.4998 10.3582 16.479 10.614 16.7098C10.8707 16.9406 10.8915 17.3365 10.6607 17.5923C9.98736 18.3398 9.10153 18.7515 8.16486 18.7515Z",
    fill: "#5D6373"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.32585699d70ffd0704e1eec299781c35.svg";
export { ForwardRef as ReactComponent };